module.exports = __webpack_public_path__ + "static/media/hong-kong-sign.6ef6ce1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/hong-kong-sign.svg
// module id = 127
// module chunks = 0